
import {map} from 'rxjs/operators';

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-registrationsuccess',
    templateUrl: './registrationsuccess.component.html',
    styleUrls: ['./registrationsuccess.component.css'],
    providers: [ApiServiceService]
})
export class RegistrationsuccessComponent implements OnInit {

    url: string;
    shortURL: string;

    constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private ref: ApiServiceService) {
    }

    ngOnInit() {
        this.url = this.route.snapshot.params['id'];

        this.http.post<any>(this.ref.baseURL() + 'decryptUrl', {
                url: this.url
            }).subscribe((result) => {
                if (result.status == 'success') {
                    this.shortURL = result.shortURL;
                }
            });
    }
}
